import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fmtEuro } from "@/lib/format";
import { AlertTriangle } from "lucide-react";

export function BudgetVarianceAlerts({ year, compact = false }) {
  const { data } = useQuery({
    queryKey: ["budget-variance-alerts", year],
    queryFn: async () => (await api.get(`/finance/budget/variance-alerts?year=${year}`)).data,
    staleTime: 60000,
  });
  const alerts = data?.alerts || [];
  if (!alerts.length) return null;
  const shown = compact ? alerts.slice(0, 5) : alerts;
  return (
    <div className="rounded-2xl bg-white border border-[#E3DED4] overflow-hidden" data-testid="budget-variance-alerts">
      <div className="px-5 py-3 flex items-center gap-2 bg-[#FBEFE6] text-[#9A4A22]">
        <AlertTriangle className="h-5 w-5" />
        <span className="font-semibold text-sm">Υπέρβαση προϋπολογισμού &gt;{data.threshold_pct}% · {year}</span>
        <span className="ml-auto text-xs opacity-80">{alerts.length} {alerts.length === 1 ? "λογαριασμός/μήνας" : "λογαριασμοί/μήνες"}</span>
      </div>
      <ul className="divide-y divide-[#E3DED4]">
        {shown.map((a) => (
          <li key={`${a.code}-${a.month}`} className="px-5 py-2.5 flex items-center gap-3 text-sm" data-testid={`bva-${a.code}-${a.month}`}>
            <span className="font-mono text-[10px] text-[#6F6A60]">{a.code}</span>
            <span className="text-[#45423C] truncate">{a.name}</span>
            <span className="text-xs text-[#6F6A60]">{a.month_label}</span>
            <span className="ml-auto tabular text-xs text-[#6F6A60]">{fmtEuro(a.actual)} / {fmtEuro(a.budget)}</span>
            <span className="tabular font-semibold text-[#A1493A] text-xs">+{a.over_pct}%</span>
          </li>
        ))}
      </ul>
      {compact && alerts.length > shown.length && (
        <Link to={`/pl-variance?year=${year}`} className="block px-5 py-2 text-xs font-semibold text-[#C86235] hover:underline" data-testid="bva-more">
          +{alerts.length - shown.length} ακόμη → Πραγματικά vs Προϋπολογισμός
        </Link>
      )}
    </div>
  );
}
